import { createStore } from 'vuex';

import common from './modules/common';
import embers from './modules/embers';
import surveys from './modules/surveys';
import surveyResponse from './modules/surveys/responses';
import users from './modules/users';
import oauth2 from './modules/oauth2';

export default createStore({
  modules: {
    oauth2,
    common,
    embers,
    surveys,
    surveyResponse,
    users
  }
});
